import { render, staticRenderFns } from "./BaseDropdownItem.vue?vue&type=template&id=e01a517c&"
import script from "./BaseDropdownItem.vue?vue&type=script&lang=js&"
export * from "./BaseDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports